import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import API from '../../tools/API';
import styles from "./PollResults.module.scss"
import { Poll, singleCathegory } from '../../tools/interfaces'
import { getDate } from '../../tools/getDate'


// import {singleCathegory, SingleSetting} from '../../tools/interfaces';
// import Modal from '../../components/Modal/Modal';
// import PollModal from '../../components/Modal/PollModal';
// import RemovePoll from "../../components/Modal/RemovePoll";

const Polls = () => {
    const { id } = useParams();
    const [polls, setPolls] = useState<Poll[]>([]);
    const [page, setPage] = useState(0);
    const [category, setCategory] = useState<singleCathegory | null>(null);

    useEffect(() => {
        API.getListOfPolls(id as string, page).then(res => setPolls(res?.data.data));
        API.getSingleCategory(id as string).then(res => setCategory(res?.data.data))
    }, [page]);

    return (
        <>
            <section className={styles.main}>

                <div className={styles.contentBox}>
                    <div className={styles.titleBox}>
                        <p>{category?.name}</p>
                    </div>
                    <ul className={styles.pollsList}>
                        {polls && (
                            polls.map(x => {
                                return (
                                    <li key={x.id} className={styles.listEl}>

                                        <Link to={`/wynik/${x.id}`}>
                                            <p className={styles.pollName}>{x.name}</p>
                                        </Link>
                                        <p className={styles.voteDate}>od {getDate(x.votingFrom)}</p>
                                        <p className={styles.voteDate}>do {getDate(x.votingTo)}</p>

                                    </li>
                                )
                            })
                        )}
                    </ul>
                </div>


            </section>
        </>
    )
}

export default Polls